import React, { useEffect, useState } from 'react';
import { Empty } from 'antd';
import './SurveyResult.less';
import footerLogo from '../../../assets/img/footer_logo_black.png';
import errorLogo from '../../../assets/img/error_logo.png';
import { getQueryString } from '../../../utils/utils';
import { surveyInfoApi } from '../api';

// 问卷错误页面
const SurveyError: React.FC = () => {
    const [title, setTitle] = useState('');
    const [endPage, setEndPage] = useState<string>();
    const [isEndPage, setIsEndPage] = useState<number>(0);
    const [isShowPage, setIsShowPage] = useState(false);

    const init = () => {
        let type = getQueryString('type');
        if (type === '1') {
            setTitle('感谢您的参与。');
            return;
        }
        if (type === '2') {
            setTitle('很抱歉，该问卷已下架或未发布，请稍后尝试填写。');
            return;
        }
        if (type === '3') {
            setTitle('很抱歉，您没有该问卷的填写权限。');
            return;
        }
        if (type === '4') {
            setTitle('您的认证身份不满足本次调研填写条件，感谢您的参与。');
            return;
        }
        if (type === '5') {
            setTitle('您提交的认证正在审核中，审核通过后才能作答此问卷。');
            return;
        }
    };

    // 获取问卷基本信息
    const getSurveyInfo = async () => {
        let surveyId = getQueryString('surveyId') || '';
        if (!surveyId) return;

        const res: any = await surveyInfoApi({ id: surveyId });
        if (res.status_code === 200) {
            setEndPage(res.data.endPage);
            setIsEndPage(res.data.isEndPage);
            setIsShowPage(true);
        }
    };

    useEffect(() => {
        getSurveyInfo();
        init();
    }, []);

    return (
        <div className="survey-result">
            {isEndPage && endPage && getQueryString('type') === '1' ? <div className="result-page" dangerouslySetInnerHTML={{ __html: endPage }}></div> : <Empty description={<span className="title">{title}</span>} image={errorLogo}></Empty>}
            {
                <div className="survey-footer">
                    <img src={footerLogo} alt="" />
                    <p className="footer-text">
                        <span>健康界 版权所有 All Rights Reserved.</span>
                        <span>北京华媒康讯信息技术股份有限公司</span>
                    </p>
                </div>
            }
        </div>
    );
};

export default SurveyError;
